export type LookInsidePage = {
  src: string
  caption: string
}

export const lookInsidePages: LookInsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/9xsSzQdQA1A3JnETuP6tb8/01_two-track-system.webp',
    caption: 'One room, two levels, one clock',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/axHmSTN6BcRy1Dq2HexPCC/02_6-block-clock.webp',
    caption: 'Every practice in 90, 75 or 60 minutes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7mm3QDH5YqX8XWt9LNcmtd/03_practice-01A-plan-and-clock.webp',
    caption: "Plan & Clock: today's goal, warm-up and both tracks",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ua6gCSunQV41KZZNS5kBHC/04_practice-01B-run-it.webp',
    caption: 'Run It: circuit, live game and finisher',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nZMsir78nh2ArZjnjoiFSp/05_field-card.webp',
    caption: 'The whole volume on one card',
  },
]
